import { useState } from 'react'

import BottomContent from 'Root/Pages/Content/Component/BottomContent'

import Container from '../../Component/Container/index'
import StatusDefault from './Status/Default'

const QuizType = ({ content, collectionVisibility, collectionPreparatory }) => {
  const [isCompleted, setIsCompleted] = useState(
    content.hasUserCompleted || false
  )

  return (
    <Container
      content={content}
      isCompleted={isCompleted}
      collectionVisibility={collectionVisibility}
      collectionPreparatory={collectionPreparatory}
    >
      <StatusDefault content={content} setIsCompleted={setIsCompleted} />
      <div className="flex flex-col gap-y-3 p-6">
        <BottomContent content={content} />
      </div>
    </Container>
  )
}

export default QuizType
